// extracted by mini-css-extract-plugin
module.exports = {"back":"h1-C4CLcGh-26tNPAaMCdg=="};